import React, { useSyncExternalStore } from 'react';
import { createPortal } from 'react-dom';
import { Sigma, X } from 'lucide-react';
import { tagThemeClass } from './tagTheme';

// askSummary() → Promise<true | false | null>: add the summary page to an item / image list PDF?
let pending = null;
const subs = new Set();
const emit = () => subs.forEach((f) => f());
export function askSummary() {
  return new Promise((resolve) => { pending = resolve; emit(); });
}
const answer = (v) => { const r = pending; pending = null; emit(); if (r) r(v); };

export function TagSummaryAskHost() {
  const open = useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => !!pending);
  if (!open) return null;
  return createPortal(
    <div className={`tag-scope ${tagThemeClass()} fixed inset-0 z-[400] flex items-end justify-center p-3 sm:items-center`} data-testid="tagws-summary-ask-dialog">
      <div className="absolute inset-0 bg-black/50" onClick={() => answer(null)} />
      <div className="relative z-10 w-full max-w-sm rounded-2xl border border-border bg-card p-5 shadow-2xl animate-in fade-in slide-in-from-bottom-2 duration-200">
        <div className="mb-2 flex items-start justify-between gap-3">
          <span className="grid h-10 w-10 place-items-center rounded-xl bg-primary/10 text-primary"><Sigma size={18} /></span>
          <button onClick={() => answer(null)} aria-label="Close" data-testid="tagws-summary-ask-close"><X size={18} /></button>
        </div>
        <h3 className="font-semibold text-foreground">Print the summary too?</h3>
        <p className="mt-1 text-sm text-muted-foreground">Adds a summary at the end: gross &amp; net weight, diamonds, colour stones, pearls, labour and other charges, one box per gold purity plus a grand total.</p>
        <div className="mt-4 grid grid-cols-2 gap-2">
          <button type="button" onClick={() => answer(false)} className="h-10 rounded-xl border border-border bg-background text-sm font-semibold text-foreground hover:bg-secondary" data-testid="tagws-summary-ask-no">No, list only</button>
          <button type="button" onClick={() => answer(true)} className="h-10 rounded-xl bg-primary text-sm font-semibold text-primary-foreground hover:opacity-90" data-testid="tagws-summary-ask-yes">Yes, add summary</button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
